import React, { useState, useRef, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  Button,
  TextField,
  Divider,
  IconButton,
  Switch,
  FormControlLabel,
  Collapse,
  Chip,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import { pageScrollStyle } from "../../../styles/styles";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { backend_api } from "../../../static/server";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllRoles } from "../../../redux/Apps/users/userSlice";
import { CloseRounded, KeyboardArrowDownRounded } from "@mui/icons-material";

const Access_modules = [
  {
    mText: "Dashboard",
    path: "/dashboard",
    id: "access_dashboard_page",
    sidebarId: "sidebar_dashboard",
    can_t_disable: true,
    description: "Main dashboard and overview pages",
    subMenu: [
      {
        mText: "Firm Dashboard",
        id: "access_firm_dashboard",
        description: "Access to firm-wide analytics and metrics",
        permissions: [
          {
            key: "graph1",
            label: "Graph 1",
            id: "access_firm_dashboard_graph1",
            description: "View first analytics graph",
          },
          {
            key: "graph2",
            label: "Graph 2",
            id: "access_firm_dashboard_graph2",
            description: "View second analytics graph",
          },
          {
            key: "graph3",
            label: "Graph 3",
            id: "access_firm_dashboard_graph3",
            description: "View third analytics graph",
          },
          {
            key: "analytics",
            label: "Analytics",
            id: "access_firm_dashboard_analytics",
            description: "Access detailed analytics data",
          },
        ],
      },
    ],
  },
  {
    mText: "Calendar",
    path: "/dashboard/calendars",
    id: "access_calendar_page",
    sidebarId: "sidebar_calendar",
    description: "Calendar and event management system",
    permissions: [
      {
        key: "create",
        label: "Create Events",
        id: "access_calendar_create",
        description: "Allow creating new calendar events",
      },
      {
        key: "edit",
        label: "Edit Events",
        id: "access_calendar_edit",
        description: "Allow editing existing calendar events",
      },
      {
        key: "delete",
        label: "Delete Events",
        id: "access_calendar_delete",
        description: "Allow deleting calendar events",
      },
      {
        key: "manage_others",
        label: "Manage Others' Events",
        id: "access_calendar_manage_others",
        description: "Manage calendar events created by other users",
      },
    ],
  },
  {
    mText: "Tasks",
    excludePaths: ["/dashboard/tasks/archived"],
    id: "access_task_page",
    sidebarId: "sidebar_tasks",
    description: "Task management and tracking system",
    subMenu: [
      {
        mText: "All Tasks",
        path: "/dashboard/tasks",
        id: "access_all_task_page",
        sidebarId: "sidebar_all_tasks",
        description: "View and manage all tasks",
        permissions: [
          {
            key: "create",
            label: "Create",
            id: "access_new_task_btn",
            description: "Create new tasks",
          },
          {
            key: "edit",
            label: "Edit",
            id: "access_new_task_edit_btn",
            description: "Edit existing tasks",
          },
          {
            key: "delete",
            label: "Delete",
            id: "access_new_task_del_btn",
            description: "Delete tasks",
          },
          {
            key: "assign",
            label: "Assign to Others",
            id: "access_assign_to_other",
            description: "Assign tasks to other team members",
          },
          {
            key: "private",
            label: "Can create private task",
            id: "access_privat_task_input",
            description: "Create tasks marked as private",
          },
        ],
      },
      {
        mText: "Task Lists",
        path: "/dashboard/task/lists",
        id: "access_task_list_page",
        sidebarId: "sidebar_task_lists",
        description: "Manage task lists and categories",
        permissions: [
          {
            key: "create",
            label: "Create Lists",
            id: "access_add_task_list",
            description: "Create new task lists",
          },
          {
            key: "edit",
            label: "Edit Lists",
            id: "access_edit_task_list",
            description: "Edit existing task lists",
          },
          {
            key: "delete",
            label: "Delete Lists",
            id: "access_delete_task_list",
            description: "Delete task lists",
          },
        ],
      },
      {
        mText: "Task Type",
        path: "/dashboard/task/type",
        id: "access_task_type_page",
        sidebarId: "sidebar_task_type",
        description: "Manage task types and classifications",
        permissions: [
          {
            key: "create",
            label: "Create Types",
            id: "access_add_task_type",
            description: "Create new task types",
          },
          {
            key: "edit",
            label: "Edit Types",
            id: "access_edit_task_type",
            description: "Edit existing task types",
          },
          {
            key: "delete",
            label: "Delete Types",
            id: "access_delete_task_type",
            description: "Delete task types",
          },
        ],
      },
      {
        mText: "Task Feed",
        path: "/dashboard/tasks/feeds",
        id: "access_task_feed_page",
        sidebarId: "sidebar_task_feed",
        description: "View task activity feed and updates",
        permissions: [
          {
            key: "comment",
            label: "Comment",
            id: "access_task_feed_comment",
            description: "Add comments to task feed",
          },
        ],
      },
    ],
  },
  {
    mText: "Matters",
    id: "access_matters_page",
    sidebarId: "sidebar_matters",
    description: "Legal matter and case management",
    subMenu: [
      {
        mText: "All Matters",
        path: "/dashboard/matter",
        id: "access_all_matters_page",
        sidebarId: "sidebar_all_matters",
        description: "View and manage all legal matters",
        permissions: [
          {
            key: "create",
            label: "Create",
            id: "access_matters_create",
            description: "Create new legal matters",
          },
          {
            key: "edit",
            label: "Edit",
            id: "access_matters_edit",
            description: "Edit existing matters",
          },
          {
            key: "delete",
            label: "Delete",
            id: "access_matters_delete",
            description: "Delete matters",
          },
          {
            key: "close",
            label: "Close Matters",
            id: "access_matters_close",
            description: "Mark matters as closed",
          },
          {
            key: "archive",
            label: "Archive",
            id: "access_matters_archive",
            description: "Archive completed matters",
          },
        ],
      },
      {
        mText: "Stages",
        path: "/dashboard/matter-stages",
        id: "access_matter_stages_page",
        sidebarId: "sidebar_matter_stages",
        description: "Manage matter workflow stages",
        permissions: [
          {
            key: "create",
            label: "Create Stages",
            id: "access_matter_stages_create",
            description: "Create new matter stages",
          },
          {
            key: "edit",
            label: "Edit Stages",
            id: "access_matter_stages_edit",
            description: "Edit existing matter stages",
          },
          {
            key: "delete",
            label: "Delete Stages",
            id: "access_matter_stages_delete",
            description: "Delete matter stages",
          },
        ],
      },
      {
        mText: "Templates",
        path: "/dashboard/matter-template",
        id: "access_matter_templates_page",
        sidebarId: "sidebar_matter_templates",
        description: "Manage matter templates",
        permissions: [
          {
            key: "create",
            label: "Create Templates",
            id: "access_matter_templates_create",
            description: "Create new matter templates",
          },
          {
            key: "edit",
            label: "Edit Templates",
            id: "access_matter_templates_edit",
            description: "Edit existing templates",
          },
          {
            key: "delete",
            label: "Delete Templates",
            id: "access_matter_templates_delete",
            description: "Delete matter templates",
          },
        ],
      },
    ],
  },
  {
    mText: "Contacts",
    path: "/dashboard/contact-details",
    id: "access_contacts_page",
    sidebarId: "sidebar_contacts",
    description: "Contact and client management",
    excludePaths: [
      "/dashboard/contacts/trash",
      "/dashboard/contacts/export-history",
    ],
    permissions: [
      {
        key: "create",
        label: "Create",
        id: "access_contacts_create",
        description: "Add new contacts",
      },
      {
        key: "edit",
        label: "Edit",
        id: "access_contacts_edit",
        description: "Edit existing contacts",
      },
      {
        key: "delete",
        label: "Delete",
        id: "access_contacts_delete",
        description: "Delete contacts",
      },
      {
        key: "export",
        label: "Export",
        id: "access_contacts_export",
        description: "Export contact data",
      },
      {
        key: "import",
        label: "Import",
        id: "access_contacts_import",
        description: "Import contact data",
      },
    ],
  },
  {
    mText: "Activities",
    path: "/dashboard/activities",
    id: "access_activities_page",
    sidebarId: "sidebar_activities",
    description: "Activity tracking and time logging",
    permissions: [
      {
        key: "create",
        label: "Create",
        id: "access_activities_create",
        description: "Create new activities",
      },
      {
        key: "edit",
        label: "Edit",
        id: "access_activities_edit",
        description: "Edit existing activities",
      },
      {
        key: "delete",
        label: "Delete",
        id: "access_activities_delete",
        description: "Delete activities",
      },
      {
        key: "log_time",
        label: "Log Time",
        id: "access_activities_log_time",
        description: "Log time entries for activities",
      },
      {
        key: "add_exp",
        label: "Log Expense",
        id: "access_activities_add_exp",
        description: "Add expense entries",
      },
      {
        key: "add_exp_categories",
        label: "Can add categories",
        id: "access_activities_add_exp_categories",
        description: "Create new expense categories",
      },
    ],
  },
  {
    mText: "Billing",
    path: "/dashboard/bills",
    id: "access_billing_page",
    sidebarId: "sidebar_billing",
    description: "Billing and invoice management",
    permissions: [
      {
        key: "create",
        label: "Create Bills",
        id: "access_billing_create",
        description: "Create new bills and invoices",
      },
      {
        key: "edit",
        label: "Edit Bills",
        id: "access_billing_edit",
        description: "Edit existing bills",
      },
      {
        key: "delete",
        label: "Delete Bills",
        id: "access_billing_delete",
        description: "Delete bills and invoices",
      },
      {
        key: "send",
        label: "Send Bills",
        id: "access_billing_send",
        description: "Send bills to clients",
      },
      {
        key: "download",
        label: "Download Bills",
        id: "access_billing_download",
        description: "Download bill documents",
      },
      {
        key: "approve",
        label: "Approve Bills",
        id: "access_billing_approve",
        description: "Approve bills before sending",
      },
      {
        key: "payment",
        label: "Record Payments",
        id: "access_billing_payment",
        description: "Record bill payments",
      },
    ],
  },
  {
    mText: "Accounts",
    id: "access_accounts_page",
    sidebarId: "sidebar_accounts",
    description: "Financial account management",
    subMenu: [
      {
        mText: "All Accounts",
        path: "/dashboard/bank_accounts",
        id: "access_all_accounts_page",
        sidebarId: "sidebar_all_accounts",
        description: "View and manage all financial accounts",
        permissions: [
          {
            key: "create",
            label: "Create Accounts",
            id: "access_accounts_create",
            description: "Create new financial accounts",
          },
          {
            key: "edit",
            label: "Edit Accounts",
            id: "access_accounts_edit",
            description: "Edit existing accounts",
          },
          {
            key: "delete",
            label: "Delete Accounts",
            id: "access_accounts_delete",
            description: "Delete financial accounts",
          },
          {
            key: "view_client_account",
            label: "Client's Accounts",
            id: "access_accounts_view_client",
            description: "View client financial accounts",
          },
          {
            key: "view_firm_account",
            label: "Firm's Accounts",
            id: "access_accounts_view_firm",
            description: "View firm's financial accounts",
          },
        ],
      },
      {
        mText: "Transactions",
        path: "/dashboard/bank_accounts/:id/:accountName/",
        id: "access_transactions_page",
        sidebarId: "sidebar_transactions",
        description: "Manage account transactions",
        permissions: [
          {
            key: "edit",
            label: "Edit Statements",
            id: "access_transactions_edit",
            description: "Edit transaction statements",
          },
          {
            key: "delete",
            label: "Delete Statements",
            id: "access_transactions_delete",
            description: "Delete transaction statements",
          },
          {
            key: "tranfer_funds",
            label: "transfer Funds",
            id: "access_transactions_transfer",
            description: "Transfer funds between accounts",
          },
          {
            key: "new_transactions",
            label: "New Transactions",
            id: "access_transactions_new",
            description: "Create new transactions",
          },
          {
            key: "export_statement",
            label: "Export Statements",
            id: "access_transactions_export",
            description: "Export transaction statements",
          },
        ],
      },
    ],
  },
  {
    mText: "Documents",
    path: "/dashboard/documents",
    id: "access_documents_page",
    sidebarId: "sidebar_documents",
    description: "Document management system",
    excludePaths: [
      "/dashboard/documents/trash",
      "/dashboard/documents/versions",
    ],
    permissions: [
      {
        key: "upload",
        label: "Upload",
        id: "access_documents_upload",
        description: "Upload new documents",
      },
      {
        key: "download",
        label: "Download",
        id: "access_documents_download",
        description: "Download documents",
      },
      {
        key: "edit",
        label: "Edit",
        id: "access_documents_edit",
        description: "Edit document properties",
      },
      {
        key: "delete",
        label: "Delete",
        id: "access_documents_delete",
        description: "Delete documents",
      },
      {
        key: "share",
        label: "Share",
        id: "access_documents_share",
        description: "Share documents with others",
      },
    ],
    subMenu: [
      {
        mText: "Templates",
        path: "/dashboard/documents/templates",
        id: "access_document_templates_page",
        sidebarId: "sidebar_document_templates",
        description: "Manage document templates",
        permissions: [
          {
            key: "create",
            label: "Create Templates",
            id: "access_document_templates_create",
            description: "Create new document templates",
          },
          {
            key: "edit",
            label: "Edit Templates",
            id: "access_document_templates_edit",
            description: "Edit existing templates",
          },
          {
            key: "delete",
            label: "Delete Templates",
            id: "access_document_templates_delete",
            description: "Delete document templates",
          },
        ],
      },
      {
        mText: "Categories",
        path: "/dashboard/documents/categories",
        id: "access_document_categories_page",
        sidebarId: "sidebar_document_categories",
        description: "Manage document categories",
        permissions: [
          {
            key: "create",
            label: "Create Categories",
            id: "access_document_categories_create",
            description: "Create new document categories",
          },
          {
            key: "edit",
            label: "Edit Categories",
            id: "access_document_categories_edit",
            description: "Edit existing categories",
          },
          {
            key: "delete",
            label: "Delete Categories",
            id: "access_document_categories_delete",
            description: "Delete document categories",
          },
        ],
      },
    ],
  },
  {
    mText: "Communications",
    path: "/dashboard/communications",
    id: "access_communications_page",
    sidebarId: "sidebar_communications",
    description: "Communication and messaging system",
    permissions: [
      {
        key: "send",
        label: "Send Messages",
        id: "access_communications_send",
        description: "Send messages and communications",
      },
      {
        key: "email",
        label: "Email Access",
        id: "access_communications_email",
        description: "Access email functionality",
      },
      {
        key: "sms",
        label: "SMS Access",
        id: "access_communications_sms",
        description: "Access SMS messaging",
      },
    ],
  },
  {
    mText: "Reports",
    path: "/dashboard/reports",
    id: "access_reports_page",
    sidebarId: "sidebar_reports",
    description: "Reporting and analytics system",
    permissions: [
      {
        key: "create",
        label: "Create Reports",
        id: "access_reports_create",
        description: "Create new reports",
      },
      {
        key: "export",
        label: "Export Reports",
        id: "access_reports_export",
        description: "Export reports to various formats",
      },
      {
        key: "schedule",
        label: "Schedule Reports",
        id: "access_reports_schedule",
        description: "Schedule automated report generation",
      },
      {
        key: "financial",
        label: "Financial Reports",
        id: "access_reports_financial",
        description: "Access financial reporting",
      },
    ],
  },
  {
    mText: "App Integrations",
    id: "access_integrations_page",
    sidebarId: "sidebar_integrations",
    description: "Third-party application integrations",
    permissions: [
      {
        key: "configure",
        label: "Configure",
        id: "access_integrations_configure",
        description: "Configure integration settings",
      },
      {
        key: "connect",
        label: "Connect Apps",
        id: "access_integrations_connect",
        description: "Connect new applications",
      },
      {
        key: "disconnect",
        label: "Disconnect Apps",
        id: "access_integrations_disconnect",
        description: "Disconnect existing integrations",
      },
    ],
  },
  {
    mText: "Custom Fields",
    path: "/dashboard/custom_fields",
    id: "access_custom_fields_page",
    sidebarId: "sidebar_custom_fields",
    description: "Manage custom data fields",
    permissions: [
      {
        key: "create",
        label: "Create Fields",
        id: "access_custom_fields_create",
        description: "Create new custom fields",
      },
      {
        key: "edit",
        label: "Edit Fields",
        id: "access_custom_fields_edit",
        description: "Edit existing custom fields",
      },
      {
        key: "delete",
        label: "Delete Fields",
        id: "access_custom_fields_delete",
        description: "Delete custom fields",
      },
    ],
  },
  {
    mText: "Settings",
    path: "/dashboard/settings",
    id: "access_settings_page",
    sidebarId: "sidebar_settings",
    description: "System settings and configuration",
    excludePaths: ["/dashboard/settings/advanced", "/dashboard/settings/logs"],
    permissions: [
      {
        key: "edit",
        label: "Edit Settings",
        id: "access_settings_edit",
        description: "Edit system settings",
      },
      {
        key: "user_management",
        label: "User Management",
        id: "access_settings_user_management",
        description: "Manage users and permissions",
      },
      {
        key: "system_config",
        label: "System Configuration",
        id: "access_settings_system_config",
        description: "Configure system-wide settings",
      },
    ],
    subMenu: [
      {
        mText: "Users & Roles",
        path: "/dashboard/settings/users-roles",
        id: "access_users_roles_page",
        sidebarId: "sidebar_users_roles",
        permissions: [
          {
            key: "invite",
            label: "Invite Users",
            id: "access_invite_user_button",
            description: "Invite new users",
          },
          {
            key: "delete_user",
            label: "Delete Users",
            id: "access_delete_user_button",
            description: "Delete existing users",
          },
          {
            key: "delete_role",
            label: "Delete Roles",
            id: "access_delete_role_button",
            description: "Delete roles",
          },
        ],
      },
    ],
  },
];

export const getProtectedPaths = () => {
  const paths = [];

  Access_modules.forEach((module) => {
    if (module.path) {
      paths.push(module.path);
    }

    if (module.subMenu) {
      module.subMenu.forEach((subItem) => {
        if (subItem.path) {
          paths.push(subItem.path);
        }
      });
    }
  });

  return [...new Set(paths)].sort();
};

export const getExcludedPaths = () => {
  const excludedPaths = [];

  Access_modules.forEach((module) => {
    if (module.excludePaths) {
      excludedPaths.push(...module.excludePaths);
    }

    if (module.subMenu) {
      module.subMenu.forEach((subItem) => {
        if (subItem.excludePaths) {
          excludedPaths.push(...subItem.excludePaths);
        }
      });
    }
  });

  return [...new Set(excludedPaths)].sort();
};

const CustomRoleDrawer = ({ open, onClose, isEditMode, editRoleData }) => {
  const dispatch = useDispatch();
  const [expandedSections, setExpandedSections] = useState({});
  const [expandedPermissions, setExpandedPermissions] = useState({});
  const [isSumbmitting, setIsSumbmitting] = useState(false);
  const { token } = useSelector((data) => data.user);

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (open) {
      if (isEditMode && editRoleData) {
        setPermissionsFromUserData(editRoleData);
      } else {
        enableAllPermissions();
      }
    }
  }, [open, isEditMode, editRoleData]);

  const enableAllPermissions = () => {
    const formData = {};

    Access_modules.forEach((module) => {
      const moduleField = `access_${module.mText
        .toLowerCase()
        .replace(/\s+/g, "_")}`;

      formData[moduleField] = true; // key will add to formdata obj key:true, key ex = access_dashboard etc.

      if (module.permissions) {
        module.permissions.forEach((permission) => {
          formData[`${moduleField}_${permission.key}`] = true; //key will add formdata obj to key:true key ex = access_dashboard etc.
        });
      }

      if (module.subMenu) {
        module.subMenu.forEach((submodule) => {
          const submoduleField = `access_${submodule.mText
            .toLowerCase()
            .replace(/\s+/g, "_")}`;

          formData[submoduleField] = true;

          if (submodule.permissions) {
            submodule.permissions.forEach((permission) => {
              formData[`${submoduleField}_${permission.key}`] = true;
            });
          }
        });
      }
    });

    Object.keys(formData).forEach((key) => {
      // this loop will enable all the permistion
      setValue(key, formData[key]);
    });
  };

  const setPermissionsFromUserData = (accessData) => {
    const formData = {};

    Access_modules.forEach((module) => {
      const moduleField = `access_${module.mText
        .toLowerCase()
        .replace(/\s+/g, "_")}`;

      formData[moduleField] = false;

      if (module.permissions) {
        module.permissions.forEach((permission) => {
          formData[`${moduleField}_${permission.key}`] = false;
        });
      }

      if (module.subMenu) {
        module.subMenu.forEach((submodule) => {
          const submoduleField = `access_${submodule.mText
            .toLowerCase()
            .replace(/\s+/g, "_")}`;

          formData[submoduleField] = false;

          if (submodule.permissions) {
            submodule.permissions.forEach((permission) => {
              formData[`${submoduleField}_${permission.key}`] = false;
            });
          }
        });
      }
    });

    Object.keys(formData).forEach((key) => {
      setValue(key, false);
    });

    const {
      modules_id = [],
      pages_id = {},
      modules_path = [],
    } = accessData.custom_access;

    Access_modules.forEach((module) => {
      const moduleField = `access_${module.mText
        .toLowerCase()
        .replace(/\s+/g, "_")}`;

      if (modules_id.includes(module.sidebarId) || module.can_t_disable) {
        setValue(moduleField, true);
      }

      if (module.subMenu) {
        module.subMenu.forEach((submodule) => {
          const submoduleField = `access_${submodule.mText
            .toLowerCase()
            .replace(/\s+/g, "_")}`;

          if (modules_id.includes(submodule.sidebarId)) {
            setValue(submoduleField, true);
          }
        });
      }

      const moduleKeyForPages =
        module.id.replace(/^access_/, "").replace(/_page$/, "") + "_module";
      const enabledPermissions = pages_id[moduleKeyForPages] || [];

      if (module.permissions) {
        module.permissions.forEach((permission) => {
          if (enabledPermissions.includes(permission.id)) {
            setValue(`${moduleField}_${permission.key}`, true);
          }
        });
      }

      if (module.subMenu) {
        module.subMenu.forEach((submodule) => {
          const submoduleField = `access_${submodule.mText
            .toLowerCase()
            .replace(/\s+/g, "_")}`;

          if (submodule.permissions) {
            submodule.permissions.forEach((permission) => {
              if (enabledPermissions.includes(permission.id)) {
                setValue(`${submoduleField}_${permission.key}`, true);
              }
            });
          }
        });
      }
    });

    if (editRoleData.role_name) {
      setValue("role_name", editRoleData.role_name);
    }
    if (editRoleData.description) {
      setValue("role_description", editRoleData.description);
    }
  };

  useEffect(() => {
    if (!open) {
      reset();
      setExpandedSections({});
      setExpandedPermissions({});
    }
  }, [open, reset]);

  const onSubmit = async (data) => {
    const modules_id = [];
    const pages_id = {};
    const allowedPaths = [];

    Access_modules.forEach((module) => {
      const moduleField = `access_${module.mText
        .toLowerCase()
        .replace(/\s+/g, "_")}`;

      const isModuleEnabled = data[moduleField];
      const moduleKeyForPages =
        module.id.replace(/^access_/, "").replace(/_page$/, "") + "_module";

      if (isModuleEnabled) {
        modules_id.push(module.sidebarId);

        if (!pages_id[moduleKeyForPages]) pages_id[moduleKeyForPages] = [];
        pages_id[moduleKeyForPages].push(module.id);

        if (module.path) allowedPaths.push(module.path);

        if (module.permissions) {
          module.permissions.forEach((permission) => {
            const permField = `${moduleField}_${permission.key}`;
            if (data[permField]) {
              pages_id[moduleKeyForPages].push(permission.id);
            }
          });
        }

        if (module.subMenu) {
          module.subMenu.forEach((submodule) => {
            const submoduleField = `access_${submodule.mText
              .toLowerCase()
              .replace(/\s+/g, "_")}`;
            const isSubmoduleEnabled = data[submoduleField];

            if (isSubmoduleEnabled) {
              modules_id.push(submodule.sidebarId);

              pages_id[moduleKeyForPages].push(submodule.id);

              if (submodule.path) allowedPaths.push(submodule.path);

              if (submodule.permissions) {
                submodule.permissions.forEach((permission) => {
                  const permField = `${submoduleField}_${permission.key}`;
                  if (data[permField]) {
                    pages_id[moduleKeyForPages].push(permission.id);
                  }
                });
              }
            }
          });
        }
      }
    });

    const uniqueModulesId = [...new Set(modules_id)].sort();
    const uniqueAllowedPaths = [...new Set(allowedPaths)].sort();

    // Remove duplicates from pages_id arrays
    Object.keys(pages_id).forEach((key) => {
      pages_id[key] = [...new Set(pages_id[key])].sort();
    });

    const submit_data = {
      role_name: data?.role_name,
      description: data?.role_description,
      access_level: "high",
      custom_access: {
        modules_id: uniqueModulesId,
        pages_id,
        modules_path: uniqueAllowedPaths,
      },
    };

    setIsSumbmitting(true);
    try {
      let response;
      if (isEditMode && editRoleData?.id) {
        response = await axios.put(
          `${backend_api}lawer/user-access/${editRoleData.id}/`,
          submit_data,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );
        toast.success("Custom Access Updated Successfully.");
      } else {
        response = await axios.post(
          `${backend_api}lawer/user-access/`,
          submit_data,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log(response);
        toast.success("Custom Access Created.");
      }
    } catch (err) {
      toast.error(
        isEditMode
          ? "Failed to update user Access"
          : "Failed to create user Access"
      );
      console.error("error in create role for user:", err);
    } finally {
      reset();
      onClose();
      setIsSumbmitting(false);
      dispatch(
        getAllRoles({
          page: 1,
          token: token,
        })
      );
    }
  };

  const toggleSection = (sectionKey) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  const togglePermissions = (itemKey) => {
    setExpandedPermissions((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const handleModuleAccess = (itemText, checked) => {
    const fieldName = `access_${itemText.toLowerCase().replace(/\s+/g, "_")}`;
    setValue(fieldName, checked);

    if (!checked) {
      const item = Access_modules.find((m) => m.mText === itemText);

      if (item?.permissions) {
        item.permissions.forEach((perm) => {
          setValue(`${fieldName}_${perm.key}`, false);
        });
      }

      if (item?.subMenu) {
        item.subMenu.forEach((subItem) => {
          const subFieldName = `access_${subItem.mText
            .toLowerCase()
            .replace(/\s+/g, "_")}`;
          setValue(subFieldName, false);

          if (subItem.permissions) {
            subItem.permissions.forEach((perm) => {
              setValue(`${subFieldName}_${perm.key}`, false);
            });
          }
        });
      }
    }
  };

  const handleSubModuleAccess = (parentText, subItemText, checked) => {
    const fieldName = `access_${subItemText
      .toLowerCase()
      .replace(/\s+/g, "_")}`;
    setValue(fieldName, checked);

    if (!checked) {
      const parentItem = Access_modules.find((m) => m.mText === parentText);
      const subItem = parentItem?.subMenu?.find((s) => s.mText === subItemText);

      if (subItem?.permissions) {
        subItem.permissions.forEach((perm) => {
          setValue(`${fieldName}_${perm.key}`, false);
        });
      }
    }
  };

  const renderPermissionChips = (item, parentKey = null) => {
    if (!item.permissions) return null;

    const baseFieldName = parentKey
      ? `access_${item.mText.toLowerCase().replace(/\s+/g, "_")}`
      : `access_${item.mText.toLowerCase().replace(/\s+/g, "_")}`;

    const permissionKey = parentKey ? `${parentKey}_${item.mText}` : item.mText;

    const parentFieldName = parentKey
      ? `access_${parentKey.toLowerCase().replace(/\s+/g, "_")}`
      : baseFieldName;

    const isParentEnabled = watch(parentFieldName);
    const isCurrentEnabled = watch(baseFieldName);

    return (
      <Box sx={{ mt: 1 }}>
        <Button
          size="small"
          variant="text"
          onClick={() => togglePermissions(permissionKey)}
          disabled={!isParentEnabled || !isCurrentEnabled}
          sx={{
            fontSize: "0.75rem",
            textTransform: "none",
            color:
              !isParentEnabled || !isCurrentEnabled
                ? "text.disabled"
                : "text.secondary",
            minWidth: "auto",
            p: 0.5,
          }}
        >
          {expandedPermissions[permissionKey] ? "Hide" : "Show"} Permissions
          <KeyboardArrowDownRounded
            fontSize="small"
            sx={{
              ml: 0.5,
              transform: expandedPermissions[permissionKey]
                ? "rotate(180deg)"
                : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          />
        </Button>

        <Collapse in={expandedPermissions[permissionKey]}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mt: 1,
              p: 1,
              bgcolor: "grey.50",
              borderRadius: 1,
            }}
          >
            {item.permissions.map((permission) => (
              <Controller
                key={permission.key}
                name={`${baseFieldName}_${permission.key}`}
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <Chip
                    label={permission.label}
                    size="small"
                    variant={value ? "filled" : "outlined"}
                    color={value ? "primary" : "default"}
                    disabled={!isParentEnabled || !isCurrentEnabled}
                    onClick={() => {
                      if (isParentEnabled && isCurrentEnabled) {
                        onChange(!value);
                      }
                    }}
                    sx={{
                      cursor:
                        isParentEnabled && isCurrentEnabled
                          ? "pointer"
                          : "not-allowed",
                      bgcolor: value ? "#00B3B0" : "transparent",
                      color: value ? "white" : "text.primary",
                      opacity: !isParentEnabled || !isCurrentEnabled ? 0.5 : 1,
                      "&:hover": {
                        bgcolor:
                          isParentEnabled && isCurrentEnabled
                            ? value
                              ? "#009B98"
                              : "action.hover"
                            : "transparent",
                      },
                    }}
                  />
                )}
              />
            ))}
          </Box>
        </Collapse>
      </Box>
    );
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "45rem",
          overflowX: "hidden",
          ...pageScrollStyle,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: "1rem 1rem 0rem 1rem",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            {isEditMode ? "Update Custom Role" : "Create Custom Role"}
          </Typography>
          <Button
            variant="text"
            size="small"
            endIcon={<CloseRounded />}
            onClick={onClose}
            sx={{
              transition: "transform 0.2s ease",
              "&:hover": { transform: "translateX(-2px)" },
            }}
          >
            Close
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                p: "1rem",
              }}
            >
              <Controller
                name="role_name"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    size="small"
                    label={
                      <>
                        Role Name <span style={{ color: "red" }}>*</span>
                      </>
                    }
                    error={!!error}
                    helperText={error ? "Role name is required" : ""}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        transition: "all 0.2s ease",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      },
                    }}
                  />
                )}
              />

              <Controller
                name="role_description"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    size="small"
                    label="Role Description"
                    multiline
                    rows={2}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        transition: "all 0.2s ease",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      },
                    }}
                  />
                )}
              />

              <Box>
                <Divider />
                <Typography
                  variant="h6"
                  sx={{
                    color: "text.secondary",
                    fontSize: "1rem",
                    fontWeight: 500,
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Access Permissions
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mb: 2,
                  }}
                >
                  Configure what this role can access and what actions they can
                  perform
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
              >
                {Access_modules.map((item, index) => (
                  <Box
                    key={item.mText}
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    <Box
                      onClick={() => item.subMenu && toggleSection(item.mText)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: "0.5rem",
                        borderRadius: "0.2rem",
                        cursor: item.subMenu ? "pointer" : "default",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Typography
                          sx={{ fontSize: "0.95rem", fontWeight: 600 }}
                        >
                          {item.mText}
                        </Typography>
                        {item.path && (
                          <Chip
                            label="Module"
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: "0.7rem", height: "1.2rem" }}
                          />
                        )}
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Controller
                          name={`access_${item.mText
                            .toLowerCase()
                            .replace(/\s+/g, "_")}`}
                          control={control}
                          defaultValue={item.can_t_disable ? true : false}
                          render={({ field: { onChange, value } }) => (
                            <Switch
                              size="small"
                              checked={value}
                              disabled={item.can_t_disable}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                onChange(checked);
                                handleModuleAccess(item.mText, checked);
                              }}
                              sx={{
                                "& .MuiSwitch-switchBase.Mui-checked": {
                                  color: "#00B3B0",
                                  "& + .MuiSwitch-track": {
                                    backgroundColor: "#00B3B0",
                                  },
                                },
                                "&.Mui-disabled": {
                                  "& .MuiSwitch-switchBase": {
                                    color: "#00B3B0",
                                  },
                                  "& .MuiSwitch-track": {
                                    backgroundColor: "#00B3B0",
                                    opacity: 0.7,
                                  },
                                },
                              }}
                            />
                          )}
                        />

                        {item.subMenu && (
                          <IconButton
                            size="small"
                            sx={{
                              transform: expandedSections[item.mText]
                                ? "rotate(0deg)"
                                : "rotate(-90deg)",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            <KeyboardArrowDownRounded fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    </Box>

                    {/* Main module permissions */}
                    {!item.subMenu && renderPermissionChips(item)}

                    {/* Submenu items */}
                    {item.subMenu && (
                      <Collapse in={expandedSections[item.mText]}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            ml: 2,
                            mt: 1,
                            pl: 2,
                            borderLeft: "2px solid",
                            borderColor: "divider",
                          }}
                        >
                          {item.subMenu.map((subItem) => (
                            <Box
                              key={subItem.mText}
                              sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                p: 1,
                                bgcolor: "grey.25",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  p: "0.4rem",
                                  borderRadius: "0.2rem",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    bgcolor: "action.hover",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    flex: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "0.85rem",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {subItem.mText}
                                  </Typography>
                                  {subItem.path && (
                                    <Chip
                                      label="Page"
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        fontSize: "0.65rem",
                                        height: "1rem",
                                      }}
                                    />
                                  )}
                                </Box>
                                <Controller
                                  name={`access_${subItem.mText
                                    .toLowerCase()
                                    .replace(/\s+/g, "_")}`}
                                  control={control}
                                  defaultValue={false}
                                  render={({ field: { onChange, value } }) => (
                                    <Switch
                                      size="small"
                                      checked={value}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        onChange(checked);
                                        handleSubModuleAccess(
                                          item.mText,
                                          subItem.mText,
                                          checked
                                        );
                                      }}
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "#00B3B0",
                                          "& + .MuiSwitch-track": {
                                            backgroundColor: "#00B3B0",
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </Box>
                              {/* Submenu permissions */}
                              {renderPermissionChips(subItem, item.mText)}
                            </Box>
                          ))}
                        </Box>
                      </Collapse>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "1rem",
                position: "sticky",
                bottom: "0rem",
                left: "0rem",
                p: "0.5rem",
                background: "rgba(255, 255, 255, 0.95)",
                boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(4px)",
                WebkitBackdropFilter: "blur(4px)",
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={onClose}
                sx={{
                  borderColor: "#00B3B0",
                  color: "#00B3B0",
                  "&:hover": {
                    borderColor: "#00B3B0",
                    bgcolor: "rgba(0, 179, 176, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={isSumbmitting}
                variant="contained"
                size="small"
                type="submit"
                sx={{
                  bgcolor: "#00B3B0",
                  "&:hover": {
                    bgcolor: "#009B98",
                  },
                  minWidth: "120px",
                }}
              >
                {isEditMode ? "Update Role" : "Create Role"}
              </LoadingButton>
            </Box>
          </Box>
        </form>
      </Box>
    </Drawer>
  );
};

export default CustomRoleDrawer;
